module.exports = __webpack_public_path__ + "static/media/tractorSleeper.49f51d09.svg";